;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export type ProtectedWorkspaceViewSection = "core" | "workflows";

export type ProtectedWorkspaceView = {
	readonly description: string;
	readonly name: string;
	readonly section: ProtectedWorkspaceViewSection;
};

export const PROTECTED_WORKSPACE_VIEWS = [
	{
		description: "Staff performance leaderboard",
		name: "Leaderboard",
		section: "core",
	},
	{
		description: "Scheduled data sync and provider workflow management",
		name: "Automations",
		section: "workflows",
	},
	{
		description: "AI agent configuration and orchestration",
		name: "Agents",
		section: "workflows",
	},
] as const satisfies readonly ProtectedWorkspaceView[];

const protectedViewNamesLower = new Set(
	PROTECTED_WORKSPACE_VIEWS.map((view) => view.name.toLowerCase()),
);

const workflowProtectedViewNamesLower = new Set(
	PROTECTED_WORKSPACE_VIEWS.filter((view) => view.section === "workflows").map(
		(view) => view.name.toLowerCase(),
	),
);

function normalizeViewName(viewName: string) {
	return viewName.trim().toLowerCase();
}

export function isProtectedWorkspaceViewName(viewName: string): boolean {
	return protectedViewNamesLower.has(normalizeViewName(viewName));
}

export function isWorkflowProtectedViewName(viewName: string): boolean {
	return workflowProtectedViewNamesLower.has(normalizeViewName(viewName));
}

export function getProtectedWorkspaceView(
	viewName: string,
): ProtectedWorkspaceView | undefined {
	const normalizedViewName = normalizeViewName(viewName);
	return PROTECTED_WORKSPACE_VIEWS.find(
		(view) => view.name.toLowerCase() === normalizedViewName,
	);
}

export function withProtectedWorkspaceViews<
	T extends { description?: string; name: string },
>(incoming: T[]): T[] {
	const existingNames = new Set(
		incoming.map((view) => normalizeViewName(view.name)),
	);
	const missingProtectedViews = PROTECTED_WORKSPACE_VIEWS.filter(
		(view) => !existingNames.has(view.name.toLowerCase()),
	);

	if (missingProtectedViews.length === 0) {
		return incoming;
	}

	return [
		...incoming,
		...missingProtectedViews.map((view) => ({
			description: view.description,
			name: view.name,
		})),
	] as T[];
}
